<template>
  <v-container>
    <Breadcrumbs :crumbs="crumbs" />
    <PageHeader>
      <template v-slot:header>昇格・昇給データ出力</template>
      <template v-slot:annotation>
        評価対象となる最後の期間と、在任期間算定日を入力し、出力ボタンを押下することで、
        <br />評価対象最後の期間から最大4期分のデータをさかのぼって評価データを集計し、昇格・昇給情報を出力します。
      </template>
    </PageHeader>

    <v-form ref="period_form">
      <v-row class="text-left px-5">
        <v-col cols="12" sm="4" md="4" lg="4">
          <v-select
            label="評価対象最後の期間（年度）"
            v-model="period"
            item-text="label"
            item-value="value"
            :items="periodItems"
            dense
            return-object
          />
        </v-col>
      </v-row>
      <v-row class="text-left px-4">
        <DatePicker
          v-model="calcData"
          rules="required"
          label="在任期間算定日"
        />
      </v-row>
      <v-row class="text-left px-4">
        <v-col>
          <Button @click="erntry_confirm" color="primary" v-if="isNotProcess"
            >出力</Button
          >
        </v-col>
      </v-row>
      <!--
      <DatePicker
        v-model="periodStartDate"
        label="評価対象の終了年月日"
      />
      <DatePicker v-model="periodEndDate" label="評価対象の開始年月日" />
      -->
    </v-form>
    <Loader :loading="loading" />
    <ConfirmDialog
      ref="confirm"
      title="昇格・昇給データ出力"
      :message="confirmMessage"
      buttonMessage="OK"
      @confirm="outputSalary"
    >
    </ConfirmDialog>

    <DialogMessage ref="dialog" />
  </v-container>
</template>

<script>
import ConfirmDialog from '@/components/Common/ConfirmMessage.vue';
import config from '../../const.js';
import axios from 'axios';
import message from '../../message.js';
import moment from 'moment';
import ExcelJS from 'exceljs';
import {
  getSessionStorageItem,
  makeDateTimeStr,
  makeSystemDateStr,
  calcDiffYear,
} from '@/common.js';
export default {
  components: {
    ConfirmDialog,
  },
  data() {
    return {
      // Breadcrumbs
      crumbs: [
        {
          name: '昇格・昇給データ出力',
          route: 'Salary',
        },
      ],
      userInfo: {},
      loading: false,
      dialog: false,
      confirmMessage: null,
      periodEndDate: '',
      periodStartDate: '',
      calcData: '',
      tmpItems: [],
      period: {},
      periodCompleteItems: [],
      periodItems: [],
      gradeData: [],
      departmentItems: [],
      positionItems: [],
      userGradeData: [],

      isNotProcess: true,
    };
  },
  created() {
    const userInfo = getSessionStorageItem();
    this.userInfo = userInfo;
    // 期間(年度)の設定
    this.getPeriod();
    // 等級データを取得
    this.getGrade();
    // 部署データを取得
    this.get_department();
    // 役職データを取得
    this.get_position();
  },
  methods: {
    async erntry_confirm() {
      // 期間(年度)チェック
      if (!this.period.value) {
        this.$refs.dialog.open(
          'info',
          '期間(年度)が選択されていません。期間(年度)は必須選択です。'
        );
        return;
      }
      if (this.calcData == null || !this.calcData) {
        this.$refs.dialog.open(
          'info',
          '在任期間算定日が選択されていません。在任期間算定日を選択して下さい。'
        );
        return;
      }

      // ユーザ情報取得
      let userInfo = getSessionStorageItem();

      //----- 目標作成状態チェック
      await axios
        .get(
          config.CONNECT_EVALUATIONS_URL +
            '/Evaluations/manages/Organization/' +
            userInfo.SESSION_ID +
            '/' +
            userInfo.USER_ID +
            '/' +
            userInfo.ORGANIZATION_KEY
        )
        .then((response) => {
          let userMakeStatus = response.data[0].GOAL_MAKE_STATUS;
          if (userMakeStatus == config.EXEC_RUN) {
            // ローディング画像終了
            this.loading = false;

            // 1:実行中の場合は処理終了
            this.$refs.dialog.open('info', message.MSG_BULK_PROGRAM_RUNNING);
            return;
          } else {
            // 確認ダイアログ表示
            this.confirmMessage =
              '昇格・昇給データを出力しますか？\n' +
              ' ※選択されている期間から最大4期分をさかのぼって評価データを集計します。\n' +
              ' ※なお、出力データを確認するにはMicrosoft Excel 2007以上が必要となります。';
            this.$refs.confirm.open();
          }
        })
        .catch((error) => {
          let errStr = '';
          if (error.status == 400) {
            errStr = message.MSG_ERROR_SESSION + error;
            this.$refs.dialog.open('error', errStr);
            return;
          } else {
            errStr = message.MSG_ERROR_SYTEM + error;
            this.$refs.dialog.open('error', errStr);
            return;
          }
        });
    },
    async outputSalary() {
      // ユーザ情報取得
      let userInfo = getSessionStorageItem();
      if (
        userInfo.ORGANIZATION_KEY != 'WORKid' &&
        userInfo.ORGANIZATION_KEY != 'craftsmith'
      ) {
        // WORKidとcraftsmith以外は使用できない(2024.7.7)
        alert('現在、昇格・昇給データ出力機能を実装中です。');
      } else {
        // ローディング画像表示
        this.loading = true;
        let vm = this;
        // ユーザ情報の取得
        // 昇格・昇給処理に使用する年月日を設定(1期を半年と考え、4期過去(2年過去)の年月日を算出)
        let periodEndDate = this.period.periodend;
        const tempDate = new Date(
          periodEndDate.substr(0, 4) +
            '-' +
            periodEndDate.substr(4, 2) +
            '-' +
            periodEndDate.substr(6, 2) +
            ' 00:00:00'
        );
        tempDate.setFullYear(tempDate.getFullYear() - 2);
        let y = tempDate.getFullYear();
        let m = tempDate.getMonth() + 1;
        let d = tempDate.getDate();
        let yyyy = y.toString();
        let mm = ('00' + m).slice(-2);
        let dd = ('00' + d).slice(-2);
        // 昇格・昇給処理で使用する終了日
        let calcPeriodEndDate = yyyy + mm + dd;
        // 在任期間算定日
        let useCalcDate = this.calcData.replace(/-/g, '');

        // 出力ボタン非活性化
        this.isNotProcess = false;

        //----- 組織キーをもとに、有効なユーザー等級データを取得
        await axios
          .get(
            config.CONNECT_EVALUATIONS_URL +
              '/Evaluations/manages/usergrade/valid/' +
              userInfo.SESSION_ID +
              '/' +
              userInfo.USER_ID +
              '/' +
              userInfo.ORGANIZATION_KEY
          )
          .then((response) => {
            // ユーザー等級データを取得
            vm.userGradeData = response.data;

            //----- 昇格・昇給データ出力リクエストPOST
            axios
              .post(
                config.CONNECT_EVALUATIONS_URL +
                  '/Evaluations/manages/salary/output',
                {
                  SESSION_ID: userInfo.SESSION_ID,
                  SESSION_USER_ID: userInfo.USER_ID,
                  ORGANIZATION_KEY: userInfo.ORGANIZATION_KEY,
                  PERIOD_END_DATE: periodEndDate,
                  CALC_PERIOD_END_DATE: calcPeriodEndDate,
                  USE_CALC_DATE: useCalcDate,
                }
              )
              .then((response) => {
                // ローディング画像終了
                this.loading = false;
                if (response.status == 200) {
                  // 成功
                  // 出力データ作成
                  let salary_data = this.onMakeExportData(
                    response.data,
                    useCalcDate,
                    userInfo.ORGANIZATION_KEY
                  );
                  // Excel出力関数コール
                  this.onExcelExport(salary_data);
                } else {
                  // 失敗
                  // 出力ボタン活性化
                  this.isNotProcess = true;
                  this.$refs.dialog.open(
                    'info',
                    '昇格・昇給データの出力が失敗しました。'
                  );
                }
              })
              .catch((error) => {
                // ローディング画像終了
                this.loading = false;

                let errStr = '';
                if (error.status == 400) {
                  errStr = message.MSG_ERROR_SESSION_ERROR + error;
                  this.$refs.dialog.open('error', errStr);
                } else {
                  errStr = message.MSG_ERROR_SYTEM_ERROR + error;
                  this.$refs.dialog.open('error', errStr);
                }
                this.resolve(true);
                this.dialog = false;
                // 出力ボタン活性化
                this.isNotProcess = true;
              });
          })
          .catch((error) => {
            let errStr = '';
            if (error.status == 400) {
              errStr = message.MSG_ERROR_SESSION + error;
              this.$refs.dialog.open('error', errStr);
              return;
            } else {
              errStr = message.MSG_ERROR_SYTEM + error;
              this.$refs.dialog.open('error', errStr);
              return;
            }
          });
      }
    },
    // 出力データ作成
    onMakeExportData(goalUserDataList, useCalcDate, organizationKey) {
      let salary_data = [];
      for (var i = 0; i < goalUserDataList.length; i++) {
        // 年度単位のデータ取得
        let goalUserDataArray = goalUserDataList[i];
        for (var j = 0; j < goalUserDataArray.length; j++) {
          // 目標ユーザー単位のデータ取得
          let goalUserDataRow = goalUserDataArray[j];
          // 評価が完了しているユーザーのみ集計開始
          if (goalUserDataRow['EVAL_STATUS'] == config.EVAL_STATUS_COMPLETE) {
            // ユーザー等級データから等級着任日を取得
            let userGradeDataRow = this.getUserGradeData(
              goalUserDataRow['USER_ID']
            );
            let gradeJoinDateTemp = String(userGradeDataRow['GRADE_JOIN_DATE']);
            let gradeJoinDate =
              gradeJoinDateTemp.substring(0, 4) +
              '/' +
              gradeJoinDateTemp.substring(4, 6) +
              '/' +
              gradeJoinDateTemp.substring(6, 8);

            // 取得した「等級着任日」と引数の「在任期間算定日」をもとに、在任期間(年)を計算
            let officePeriodYear = calcDiffYear(useCalcDate, gradeJoinDateTemp);
            // 等級データから等級名を取得
            let gradeName = this.getGradeName(userGradeDataRow['GRADE_ID']);
            // 評価期間最終日
            let periodEndDateTemp = String(goalUserDataRow['PERIOD_END_DATE']);
            let periodEndDate =
              periodEndDateTemp.substring(0, 4) +
              '/' +
              periodEndDateTemp.substring(4, 6) +
              '/' +
              periodEndDateTemp.substring(6, 8);

            // 昇格・昇給データを追加
            let salary_row = {
              USER_ID: String(goalUserDataRow['USER_ID']).replace(
                organizationKey,
                ''
              ),
              DEPARTMENT_NAME: goalUserDataRow['DEPARTMENT_NAME'],
              DEPARTMENT_NAME_SORT: Number(
                this.getDepartmentSort(userGradeDataRow['DEPARTMENT_KEY'])
              ),
              POSITION_NAME: goalUserDataRow['POSITION_NAME'],
              POSITION_NAME_SORT: Number(
                this.getPositionSort(userGradeDataRow['POSITION_ID'])
              ),
              USER_NAME: goalUserDataRow['USER_NAME'],
              USER_NAME_FURIGANA: goalUserDataRow['USER_NAME_FURIGANA'],
              GRADE_NAME: gradeName,
              GRADE_JOIN_DATE: gradeJoinDate,
              OFFICE_PERIOD_YEAR: officePeriodYear,
              PERIOD_END_DATE: periodEndDate,
              EVALUATION_SCORE: parseFloat(goalUserDataRow['EVALUATION_SCORE']),
            };
            salary_data.push(salary_row);
          }
        }
      }
      // ソート
      salary_data.sort((a, b) => {
        // 第一キー：フリガナ名称の昇順
        if (a.USER_NAME_FURIGANA > b.USER_NAME_FURIGANA) return 1;
        if (a.USER_NAME_FURIGANA < b.USER_NAME_FURIGANA) return -1;

        // 第二キー：ユーザーIDの昇順
        if (a.USER_ID > b.USER_ID) return 1;
        if (a.USER_ID < b.USER_ID) return -1;

        // 第三キー：終了日の昇順
        if (a.PERIOD_END_DATE > b.PERIOD_END_DATE) return 1;
        if (a.PERIOD_END_DATE < b.PERIOD_END_DATE) return -1;
      });

      return salary_data;
    },
    // ユーザー等級取得
    getUserGradeData(userId) {
      let userGradeData = {};
      for (var i = 0; this.userGradeData.length; i++) {
        if (this.userGradeData[i]['USER_ID'] == userId) {
          userGradeData = this.userGradeData[i];
          break;
        }
      }
      return userGradeData;
    },
    // 等級名取得
    getGradeName(gradeId) {
      let gradeName = '';
      for (var i = 0; this.gradeData.length; i++) {
        if (this.gradeData[i]['GRADE_ID'] == gradeId) {
          gradeName = this.gradeData[i]['GRADE_NAME'];
          break;
        }
      }
      return gradeName;
    },
    // 部署検索
    getDepartmentSort(departmentKey) {
      let departmentSort = 0;
      for (var i = 0; this.departmentItems.length; i++) {
        if (this.departmentItems[i]['DEPARTMENT_KEY'] == departmentKey) {
          departmentSort = this.departmentItems[i]['SHOW_ORDER'];
          break;
        }
      }
      return departmentSort;
    },
    // 役職検索
    getPositionSort(positionId) {
      let positionSort = 0;
      for (var i = 0; this.positionItems.length; i++) {
        if (this.positionItems[i]['POSITION_ID'] == positionId) {
          positionSort = this.positionItems[i]['SHOW_ORDER'];
          break;
        }
      }
      return positionSort;
    },

    // Excel出力
    async onExcelExport(data) {
      /** ヘッダ行の背景色 */
      const headerFillStyle = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFD3D3D3' },
      };
      /** ヘッダ行のフォント */
      const headerFontStyle = {
        bold: true,
      };

      // 初期化
      const workbook = new ExcelJS.Workbook(); // workbookを作成
      workbook.addWorksheet('RatingResult'); // worksheetを追加
      const worksheet = workbook.getWorksheet('RatingResult'); // 追加したworksheetを取得

      // データを用意
      // 各列のヘッダー
      worksheet.columns = [
        { header: 'ID', key: 'USER_ID', width: 20 },
        { header: '部署', key: 'DEPARTMENT_NAME', width: 25 },
        { header: '部署順', key: 'DEPARTMENT_NAME_SORT', width: 10 },
        { header: '役職', key: 'POSITION_NAME', width: 25 },
        { header: '役職順', key: 'POSITION_NAME_SORT', width: 10 },
        { header: '名前', key: 'USER_NAME', width: 20 },
        { header: 'ふりがな', key: 'USER_NAME_FURIGANA', width: 20 },
        { header: '等級', key: 'GRADE_NAME', width: 10 },
        { header: '着任日', key: 'GRADE_JOIN_DATE', width: 15 },
        { header: '在任期間（年）', key: 'OFFICE_PERIOD_YEAR', width: 13 },
        { header: '評価期間最終日', key: 'PERIOD_END_DATE', width: 15 },
        { header: '評価点数', key: 'EVALUATION_SCORE', width: 10 },
      ];
      // 各行のデータ（worksheet.columnsのkeyがオブジェクトのキーと同じになる）
      worksheet.addRows(data);

      // ヘッダーのスタイル
      worksheet.getCell('A1').fill = headerFillStyle;
      worksheet.getCell('B1').fill = headerFillStyle;
      worksheet.getCell('C1').fill = headerFillStyle;
      worksheet.getCell('D1').fill = headerFillStyle;
      worksheet.getCell('E1').fill = headerFillStyle;
      worksheet.getCell('F1').fill = headerFillStyle;
      worksheet.getCell('G1').fill = headerFillStyle;
      worksheet.getCell('H1').fill = headerFillStyle;
      worksheet.getCell('I1').fill = headerFillStyle;
      worksheet.getCell('J1').fill = headerFillStyle;
      worksheet.getCell('K1').fill = headerFillStyle;
      worksheet.getCell('L1').fill = headerFillStyle;

      worksheet.getCell('A1').font = headerFontStyle;
      worksheet.getCell('B1').font = headerFontStyle;
      worksheet.getCell('C1').font = headerFontStyle;
      worksheet.getCell('D1').font = headerFontStyle;
      worksheet.getCell('E1').font = headerFontStyle;
      worksheet.getCell('F1').font = headerFontStyle;
      worksheet.getCell('G1').font = headerFontStyle;
      worksheet.getCell('H1').font = headerFontStyle;
      worksheet.getCell('I1').font = headerFontStyle;
      worksheet.getCell('J1').font = headerFontStyle;
      worksheet.getCell('K1').font = headerFontStyle;
      worksheet.getCell('L1').font = headerFontStyle;

      // 日付の書式設定
      for (var row = 0; row < data.length; row++) {
        worksheet.getCell('I' + (2 + row)).numFmt = 'yyyy/m/d';
        worksheet.getCell('K' + (2 + row)).numFmt = 'yyyy/m/d';
      }

      // ファイル生成
      const uint8Array = await workbook.xlsx.writeBuffer();
      const blob = new Blob([uint8Array], { type: 'application/octet-binary' });
      const a = document.createElement('a');
      a.href = (window.URL || window.webkitURL).createObjectURL(blob);
      var fileName = 'RatingResult' + moment().format('YYYYMMDDHHmmss');
      a.download = fileName + `.${'xlsx'}`;
      a.click();
      a.remove();

      // 出力ボタン活性化
      this.isNotProcess = true;
      this.$refs.dialog.open('info', '昇格・昇給データの出力が成功しました。');
    },
    async getPeriod() {
      // 年度情報取得
      this.loading = true;
      let vm = this;
      await axios
        .get(
          config.CONNECT_EVALUATIONS_URL +
            '/Evaluations/manages/period/' +
            this.userInfo.SESSION_ID +
            '/' +
            this.userInfo.USER_ID +
            '/' +
            this.userInfo.ORGANIZATION_KEY
        )
        .then((response) => {
          // 年度データ取得
          vm.tmpItems = response.data;
          var nowStr = makeSystemDateStr();
          this.hasPeriod = false;
          this.initPeriodId = '';

          // 評価完了しているデータのみ格納
          for (var i = 0; i < vm.tmpItems.length; i++) {
            if (
              vm.tmpItems[i].PERIOD_STATUS == config.PERIOD_STATUS_EVAL_COMPLETE
            ) {
              var completeItem = {
                PERIOD_ID: vm.tmpItems[i].PERIOD_ID,
                PERIOD_NAME: vm.tmpItems[i].PERIOD_NAME,
                PERIOD_START_DATE: vm.tmpItems[i].PERIOD_START_DATE,
                PERIOD_END_DATE: vm.tmpItems[i].PERIOD_END_DATE,
                GOAL_INTERVAL: vm.tmpItems[i].GOAL_INTERVAL,
                PERIOD_STATUS: vm.tmpItems[i].PERIOD_STATUS,
              };
              this.periodCompleteItems.push(completeItem);
            }
          }

          // 過去2期分のデータがある年度のみ表示
          var periodCompleteCount = this.periodCompleteItems.length;

          for (var j = 0; j < this.periodCompleteItems.length; j++) {
            if (periodCompleteCount >= config.SALARY_MIN_PERIOD_DATA) {
              var periodStartDate = makeDateTimeStr(
                'S',
                this.periodCompleteItems[j].PERIOD_START_DATE
              );
              var periodEndDate = makeDateTimeStr(
                'E',
                this.periodCompleteItems[j].PERIOD_END_DATE
              );
              // 現在日時が年度開始・終了の期間内かを判定
              if (periodStartDate <= nowStr && periodEndDate >= nowStr) {
                //this.hasPeriod = true;
                this.initPeriodId = this.periodCompleteItems[j].PERIOD_ID;
              }
              var item = {
                label: this.periodCompleteItems[j].PERIOD_NAME,
                value: this.periodCompleteItems[j].PERIOD_ID,
                periodend: this.periodCompleteItems[j].PERIOD_END_DATE,
              };
              this.periodItems.push(item);
              // 年度カウントのデクリメント
              periodCompleteCount--;
            }
          }

          // ラベル設定
          for (var k = 0; k < this.periodCompleteItems.length; k++) {
            if (this.periodCompleteItems[k].PERIOD_ID == this.initPeriodId) {
              this.period.label = this.periodCompleteItems[k].PERIOD_NAME;
            }
          }

          this.period.value = this.initPeriodId;
        })
        .catch((error) => {
          let errStr = '';
          if (error.status == 400) {
            errStr = message.MSG_ERROR_SESSION + error;
            this.$refs.dialog.open('error', errStr);
          } else {
            errStr = message.MSG_ERROR_SYTEM + error;
            this.$refs.dialog.open('error', errStr);
          }
        });

      this.loading = false;
    },
    async getGrade() {
      this.loading = true;
      let vm = this;

      await axios
        .get(
          config.CONNECT_EVALUATIONS_URL +
            '/Evaluations/manages/grade/' +
            this.userInfo.SESSION_ID +
            '/' +
            this.userInfo.USER_ID +
            '/' +
            this.userInfo.ORGANIZATION_KEY
        )
        .then((response) => {
          // 等級データ取得
          vm.gradeData = response.data;
        })
        .catch((error) => {
          let errStr = '';
          if (error.status == 400) {
            errStr = message.MSG_ERROR_SESSION + error;
            this.$refs.dialog.open('error', errStr);
          } else {
            errStr = message.MSG_ERROR_SYTEM + error;
            this.$refs.dialog.open('error', errStr);
          }
        });
      // ローディング画像終了
      this.loading = false;
    },
    async get_department() {
      this.loading = true;
      let vm = this;

      await axios
        .get(
          config.CONNECT_URL +
            '/Encouragements/manage/department/' +
            this.userInfo.SESSION_ID +
            '/' +
            this.userInfo.USER_ID +
            '/' +
            this.userInfo.ORGANIZATION_KEY
        )
        .then((response) => {
          // 部署データ取得
          vm.departmentItems = response.data;
        })
        .catch((error) => {
          let errStr = '';
          if (error.status == 400) {
            errStr = message.MSG_ERROR_SESSION + error;
            this.$refs.dialog.open('error', errStr);
          } else {
            errStr = message.MSG_ERROR_SYTEM + error;
            this.$refs.dialog.open('error', errStr);
          }
        });
      // ローディング画像終了
      this.loading = false;
    },
    async get_position() {
      this.loading = true;
      let vm = this;

      await axios
        .get(
          config.CONNECT_URL +
            '/Encouragements/manage/position/' +
            this.userInfo.SESSION_ID +
            '/' +
            this.userInfo.USER_ID +
            '/' +
            this.userInfo.ORGANIZATION_KEY
        )
        .then((response) => {
          // 役職データ取得
          vm.positionItems = response.data;
        })
        .catch((error) => {
          let errStr = '';
          if (error.response.status == 404) {
            errStr = message.MSG_INFO_POSITION_NOT_FOUND;
            this.$refs.dialog.open('info', errStr);
          } else if (error.response.status == 400) {
            errStr = message.MSG_ERROR_SESSION + error;
            this.$refs.dialog.open('error', errStr);
          } else {
            errStr = message.MSG_ERROR_SYTEM + error;
            this.$refs.dialog.open('error', errStr);
          }
        });
      // ローディング画像終了
      this.loading = false;
    },
  },
};
</script>
